import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import { TabGroupMenu } from './TabGroupMenu/TabGroupMenu';
import './TabMenu.css';
import { TabMenuLink, TabMenuLinkProps } from './TabMenuLink/TabMenuLink';

export enum TabMenuSize {
    s = 's',
    m = 'm'
}

export enum TabMenuTheme {
    common = 'common',
    grey = 'grey'
}

export interface TabMenuProps {
    className?: string;
    items: Array<TabMenuLinkProps>;
    size?: TabMenuSize;
    theme?: TabMenuTheme;
    hasSeparator?: boolean;
}

const BLOCK = 'tab-menu';

export class TabMenu extends React.PureComponent<TabMenuProps> {
    render() {
        const { size = TabMenuSize.s, className } = this.props;

        return (
            <ul
                className={classNames(
                    Bem.cls({ block: BLOCK, mods: { size: size } }),
                    className
                )}
            >
                {this.getNavLinks()}
            </ul>
        );
    }

    private getNavLinks() {
        const {
            size = TabMenuSize.s,
            theme = TabMenuTheme.common,
            hasSeparator
        } = this.props;

        return this.props.items.map((item, pos) => {
            return (
                <li className={Bem.cls(BLOCK, 'item')} key={pos}>
                    {item.group ? (
                        <TabGroupMenu
                            title={item.title}
                            items={item.group}
                            size={size}
                            theme={theme}
                        />
                    ) : (
                        <TabMenuLink {...item} size={size} theme={theme} />
                    )}
                    {hasSeparator && pos < this.props.items.length - 1 && (
                        <Shape2
                            theme={Shape2Theme.light}
                            cls={Bem.cls(BLOCK, 'arrow')}
                            icon={Shape2Icon.verticalArrow}
                            width={12}
                            height={12}
                        />
                    )}
                </li>
            );
        });
    }
}
